import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

// WANTD Logo SVG (simplified)
const WantdLogo = () => (
  <svg viewBox="0 0 200 50" className="w-48 h-12 mb-6 opacity-30">
    <text x="0" y="40" fontFamily="Arial Black, sans-serif" fontSize="42" fontWeight="900" fill="currentColor">
      WANTD
    </text>
    <text x="175" y="40" fontFamily="Arial Black, sans-serif" fontSize="42" fontWeight="900" fill="#C9956C">
      .
    </text>
  </svg>
);

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[var(--theme-bg)] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Logo */}
        <div className="flex justify-center text-[var(--theme-text-primary)]">
          <WantdLogo />
        </div>
        
        {/* 404 Number */}
        <h1 className="text-8xl font-bold text-[var(--theme-text-primary)] opacity-20 mb-4">
          404
        </h1>
        
        {/* Message */}
        <h2 className="text-2xl font-bold text-[var(--theme-text-primary)] mb-2">
          Page Not Found
        </h2>
        <p className="text-[var(--theme-text-secondary)] mb-8">
          The page you're looking for doesn't exist or has been removed.
        </p>
        
        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button 
            onClick={() => window.history.back()}
            variant="outline"
            className="gap-2 border-[var(--theme-border)] text-[var(--theme-text-primary)]"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
          
          <Link to="/">
            <Button className="gap-2 bg-[#1E3A5F] hover:bg-[#2A4A6F] text-white w-full sm:w-auto">
              <Home className="w-4 h-4" />
              Back to Home
            </Button>
          </Link>
          
          <Link to="/browse">
            <Button 
              variant="outline"
              className="gap-2 border-[var(--theme-border)] text-[var(--theme-text-primary)] w-full sm:w-auto"
            >
              <Search className="w-4 h-4" />
              Browse Listings
            </Button>
          </Link>
        </div>
        
        {/* Help Text */}
        <p className="text-sm text-[var(--theme-text-secondary)] mt-8">
          If you believe this is an error, please{' '}
          <a href="mailto:support@wantd.au" className="text-[#C9956C] hover:underline">
            contact support
          </a>
        </p>
      </div>
    </div>
  );
}
